<template>
  <DialogTemplate
    id="cardsdialog"
    :actionsClass="'pt-0'"
    data-tst="cardsdialog"
  >
    <CardsPicker
      ref="picker"
      :cards="l_board"
      :visible="visibleCards"
      :lockedIndexes="lockedIndexes"
      tstPrefix="cards_dialog"
      :hasRandomize="!isEliteLocked"
      :disabled="!!isEliteLocked"
      :style="isEliteLocked ? '--min-height-cardbox:17rem' : ''"
      @update:cards="handleUpdate"
    >
      <template #cardsrows>
        <div
          v-if="!!isEliteLocked"
          class="gw_overlay_content cursor-default text-center f-center"
          style="
            --opacity: 1;
            --clr-back: rgba(0, 0, 0, 0.5);
            --clr-back: rgba(0, 0, 0, 0);
            border-radius: 4px;
          "
        >
          <div
            class="clr-grey gw_box text-medium pa-6"
            style="background: var(--clr-black-0-3)"
          >
            <div
              class="text-normal-large clr-white weight_700"
              v-html="
                hasSingleIcmFlopOnly
                  ? $t(`messages.upgrade_to_elite_unlock_all_flops_with_icm`, {
                      tier: 'MTT',
                    })
                  : hasSingleRakeFlopOnly
                    ? $t(`messages.upgrade_to_elite_unlock_all_flops_with_rake`, {
                        tier: 'Cash or Straddle Ante Cash',
                      })
                    : $t(`messages.upgrade_to_elite_unlock_all_flops`)
              "
            ></div>

            <div @click="emptyTree">
              <router-link
                class="gw_btn gw_btn-v1 gw_btn_primary weight_500 mt-4 clr-white"
                style="font-size: 0.875rem"
                :to="{
                  name: 'SubscriptionOverview',
                  query: { gm_type: hasSingleRakeFlopOnly ? 'cash' : 'mtt' },
                }"
              >
                <i class="mdi text-large mdi-crown mr-2"></i>
                {{ $t('btn.go_elite') }}
              </router-link>
            </div>

            <div
              class="d-flex f-column mt-2 mx-auto"
              style="gap: 0.5rem"
            >
              <div
                class="gw_btn-v1 clr-white f-column"
                style="font-size: 0.875rem; --brighten-active: 0.05"
                @click="apply()"
              >
                <div class="f-center">
                  <!-- TODO to properly translate to all langs Cards need to be as html var in i18n -->
                  <!-- its 프리플롭 QsTs7h 사용해 보세요 in korean etc-->
                  <!-- so create getHtmlSimpleCardRow(cards) in format_mix -->
                  Try free flop
                  <CardRowSimple
                    class="ml-2"
                    :board="'QsTs7h'"
                    style="--crds-card-height: 1.875rem; --crds-card-value-size-increase: 0.9"
                  >
                  </CardRowSimple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CardsPicker>
    <template #dialog_actions>
      <div class="d-flex f-wrap flex-1 mt-2">
        <div
          v-if="
            ['StudySolutions', 'PracticeRangeBuilder'].some(i => i === $route.name) &&
            hasCustomReportsMessage
          "
          class="mr-auto mt-auto"
          :class="'f-column'"
        >
          <TooltipUnderline
            v-if="!mobile"
            :contentStyle="'max-width: 280px!important;'"
            :underlineStyle="'--underline-clr: var(--clr-grey-2);margin-right: 0.5rem;align-self: flex-start;line-height:1.1'"
            v-bind="{
              text: $t('tooltips.reports'),
            }"
          >
            <div
              class="weight_500 uppercase clr-grey my-auto mt-2"
              v-html="$t('tabs.reports') + ':'"
            ></div>
          </TooltipUnderline>
          <div
            v-else
            class="weight_500 uppercase clr-grey my-auto mt-2 mr-2"
            v-html="$t('tabs.reports') + ':'"
          ></div>
          <div :class="mobile ? '' : 'd-flex mt-1'">
            <v-btn
              :size="true && 'small'"
              class="mr-2 mt-1"
              style="min-width: 5.5rem"
              color="var(--clr-blue-1)"
              :disabled="reportsDisabled('flop')"
              @click.stop="showReports('flop')"
            >
              {{ $t('table_head.flops') }}
            </v-btn>
            <div
              v-if="!usingCustomSol"
              class="mt-auto"
              :class="{ csst: reportsDisabled('turn') }"
            >
              <v-btn
                :size="true && 'small'"
                class="mt-1"
                style="min-width: 5.5rem"
                color="var(--clr-blue-1)"
                :disabled="reportsDisabled('turn')"
                @click.stop="showReports('turn')"
              >
                {{ $t('table_head.turns') }}
              </v-btn>
              <div
                class="csst_content text-nowrap"
                style="top: -1.75rem; left: 0"
              >
                {{ $t('tooltips.select_flop_first') }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!isEliteLocked"
          class="d-flex ml-auto mt-4"
        >
          <v-btn
            class="mr-2 mt-auto"
            data-tst="btn_reset_cards"
            @click.stop="clearAll"
          >
            {{ $t('btn.clear_all') }}
          </v-btn>

          <div
            v-if="!canConfirm"
            class="csst mt-auto"
          >
            <v-btn :disabled="true">
              {{ $t('btn.confirm') }}
            </v-btn>
            <div
              class="csst_content text-nowrap"
              style="top: -2rem; right: 0"
            >
              {{ $t('messages.select_board_strategy.title') }}
            </div>
          </div>
          <v-btn
            v-else
            :disabled="!canConfirm"
            class="mt-auto"
            color="primary"
            data-tst="btn_confirm_cards"
            @click="apply()"
          >
            {{ $t('btn.confirm') }}
          </v-btn>
        </div>
      </div>
    </template>
  </DialogTemplate>
</template>

<script>
import TooltipUnderline from '@/components/Payments/TooltipUnderline'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import CardRowSimple from '@/components/CardRow/CardRowSimple'
import CardsPicker from '@/components/CardsPicker/CardsPicker'
import { getCardsFromStr, getCardRows } from '@/helpers/cards'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'CardsDialog',
  components: {
    CardsPicker,
    TooltipUnderline,
    DialogTemplate,
    CardRowSimple,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      touched: false,
      l_board: [],
    }
  },
  created() {
    const board = getCardsFromStr(
      this.dialog.filter
        ? this.$route.query.board
        : this.$store.getters[SNK('query_board', this.namespace)],
    )
    this.l_board = [...board, 'E0', 'E2', 'E3', 'E4', 'E5'].slice(0, 5)
    if (this.isEliteLocked) {
      this.l_board[0] = 'Qs'
      this.l_board[1] = 'Ts'
      this.l_board[2] = '7h'
    }
  },
  methods: {
    clearAll() {
      this.l_board = this.usingCustomSol
        ? this.l_board.map((cc, idx) => (this.lockedIndexes.includes(idx) ? cc : `E${idx}`))
        : ['E0', 'E2', 'E3', 'E4', 'E5']
    },
    handleUpdate({ cards, trigger = 'click' }) {
      this.touched = true
      this.l_board = cards
    },
    showReports(street) {
      const soltab = 'reports'
      this.applyAndGo(street, soltab)
    },
    applyAndGo(street, soltab) {
      let hs = this.history_spot.id
      if (this.street !== street) {
        const history_spots = this.$store.getters[SNK('history_spots', this.namespace)] || []
        const firstStreetSpot = history_spots.find(spot => spot.street === street)
        hs = firstStreetSpot.id || hs
      }
      const board = this.l_board.filter(c => !c.includes('E')).join('')

      const storeAction = SNK('router_update_query', this.namespace)
      this.$store.dispatch(storeAction, {
        query: {
          board,
          history_spot: hs,
        },
        push: true,
      })

      if (soltab) {
        this.$store.dispatch('poker_sync_study_tabs', { soltab })
        this.$store.dispatch('switchers_set_item', {
          key: 'sw_tabs_study',
          item: { payload: soltab },
        })
      }

      this.$store.dispatch('router_rm_dialog', 'cards-dialog')
    },
    handleCustomSolBoardChange() {
      if (
        ['StudySolutions', 'StudyReports', 'PracticeRangeBuilder'].some(
          i => i === this.$route.name,
        ) &&
        this.usingCustomSol
      ) {
        if (
          this.isEliteLocked &&
          (this.l_board[0] !== 'Qs' || this.l_board[1] !== 'Ts' || this.l_board[2] !== '7h')
        ) {
          return
        }
        const board = this.l_board.filter(c => !c.includes('E')).join('')

        this.$store.dispatch(SNK('sol_resetApiSolutionCache', this.namespace), {
          board,
        })

        this.$store.dispatch(SNK('sol_cust_handleBoardChange', this.namespace), {
          board,
          solElite: this.solElite,
        })
      }
    },
    reportsDisabled(street) {
      if (street === 'flop') {
        return false
      }
      if (street === 'turn') {
        return this.selectedBoard.flop.some(c => c.includes('E')) || this.visibleCards <= 3
      }
      return true
    },
    apply() {
      if (this.flopSetTurnNoSet) {
        this.applyAndGo('flop')
        this.handleCustomSolBoardChange()
        return
      }
      if (!this.canConfirm) return
      this.$store.dispatch('router_rm_dialog', 'cards-dialog')
      const board = this.l_board.filter(c => !c.includes('E')).join('')

      if (this.dialog.filter) {
        this.$store.dispatch('filters_apply', {
          id: this.dialog.filter,
          value: { board },
          conf: 'unset in cards selector',
        })
        this.handleCustomSolBoardChange()
        return
      }

      if (this.boardIsTmp) {
        const storeAction = SNK('router_update_query', this.namespace)
        this.$store.dispatch(storeAction, {
          namespace: this.namespace,
          query: {
            board,
          },
          push: false,
          replace: false,
          saveLocally: false,
        })
        this.handleCustomSolBoardChange()
        return
      }

      if (this.notLastSpot) {
        this.applyAndGo(this.history_spot?.street || 'flop')
        this.handleCustomSolBoardChange()
        return
      }

      const storeAction = SNK('router_update_query', this.namespace)
      this.$store.dispatch(storeAction, {
        query: {
          board,
        },
        push: true,
      })
      this.handleCustomSolBoardChange()
    },
    emptyTree() {
      // kinda hacky but well time is short right now
      // so that custom_tree is not hangin when no solution was yet create ever and so no history exists
      this.$store.commit('api_reset', { key: 'api_poker_custom_solution_tree' })
    },
  },
  computed: {
    hasCustomReportsMessage() {
      return !this.usingCustomSol
    },
    history_spot() {
      return this.$store.getters[SNK('history_spot', this.namespace)]
    },
    street() {
      return this.$store.getters[SNK('street', this.namespace)]
    },
    selectedBoard() {
      let res = this.l_board.filter(c => !c.includes('E'))
      res = [...res, 'E0', 'E2', 'E3', 'E4', 'E5'].slice(0, 5)
      const flop = [res[0], res[1], res[2]]
      return {
        flop: flop.some(c => c.includes('E')) ? ['E0', 'E2', 'E3'] : [res[0], res[1], res[2]],
        turn: [res[3]],
        river: [res[4]],
      }
    },
    selectedCards() {
      const board = this.l_board.slice(0, this.visibleCards)
      return board.filter(c => !c.includes('E')).length
    },
    flopSetTurnNoSet() {
      const turnEmpty = this.l_board[3]?.includes('E')
      return turnEmpty && this.visibleCards === 4 && this.street === 'flop'
    },
    notLastSpot() {
      return (
        this.$store.getters[SNK('history_spots', this.namespace)].length - 1 > this.history_spot.id
      )
    },
    canConfirm() {
      let visibleBoard = this.l_board.slice(0, this.visibleCards)
      let res = visibleBoard.every(c => !c.includes('E'))
      visibleBoard = this.l_board.slice(0, 3)
      res = visibleBoard.every(c => !c.includes('E'))
      return res
    },
    mediumCards() {
      const height = window.innerHeight // big on vertical ipad
      return this.mobile && height < 1024
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    cardRows() {
      return getCardRows()
    },
    visibleCards() {
      if (this.boardIsTmp) {
        return 5
      }
      if (this.dialog.filter) {
        return 5
      }
      if (this.usingCustomSol) {
        const { street } = this.dialog
        const num = street === 'flop' ? 3 : street === 'turn' ? 4 : street === 'river' ? 5 : 3
        if (!num) {
          debugger
        }
        return num
      }
      return this.$store.getters[SNK('gamestate_visible_cards', this.namespace)]
    },
    lockedIndexes() {
      if (!this.usingCustomSol) return []
      const { street } = this.dialog
      const res =
        street === 'flop'
          ? []
          : street === 'turn'
            ? [0, 1, 2]
            : street === 'river'
              ? [0, 1, 2, 3]
              : []
      return res
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.namespace)]
    },
    eliteMTTTierPurchased() {
      return this.$store.getters.sol_eliteMTTTierPurchased
    },
    usingCustomSol() {
      return this.solElite.want_use
    },
    hasSingleFlopOnly() {
      return this.solElite.want_use &&
        this.visibleCards === 3 &&
        (this.solElite.custom_tree_id || this.solElite.custom_solution_id)
        ? this.solElite.must_upgrade
        : false
    },
    hasSingleRakeFlopOnly() {
      if (this.visibleCards > 3) return false
      const treeRake = this.solElite?.cTree?.rake
      const hasRake = treeRake?.pct_of_pot || treeRake?.cap_in_chips
      return hasRake && this.solElite.is_elite_without_rake
    },
    hasSingleIcmFlopOnly() {
      if (this.visibleCards > 3) return false
      return (
        this.solElite.want_use &&
        this.solElite.tournamentType === 'icm' &&
        !this.eliteMTTTierPurchased
      )
    },
    isEliteLocked() {
      return this.hasSingleFlopOnly || this.hasSingleRakeFlopOnly || this.hasSingleIcmFlopOnly
    },
    boardIsTmp() {
      return this.dialog.board === 'tmp'
    },
    namespace() {
      return this.dialog.namespace || ''
    },
  },
  watch: {
    l_board(l_board) {
      if (this.touched && this.$route.name === 'StudySolutions') {
        const selectedCards = l_board.filter(i => !i.includes('E'))
        if (this.visibleCards === selectedCards.length) {
          this.apply()
        }
      }
    },
  },
}
</script>
